import OfflineStore from './OfflineStore';

export default OfflineStore('OFFLINE_ANNOTATIONS', 'ANNOTATIONS');
